import React, {Component} from "react";
import {Translate} from "react-i18nify";

import * as config from "../../../constants/config";
import * as modelHelper from "../../../helpers/modelHelper";
import * as resources from "../../../constants/resources";

import Modal from "../generic/Modal";
import CloseButton from "../generic/CloseButton";

import imgDeso from "../../../resources/img/deso-logo.png";
import Button from "../generic/Button";

export default class HelpModalGamma extends Component {
    componentDidMount = () => {
        this.props.getHelperIsOnline();
    };

    handleCloseModalClick = () => {
        this.props.closeModal();
    };

    handleOpenBugReportSection = () => {
        this.props.openBugReportSection();
    };

    getBugReportButton = () => {
        if (this.props.loggedUser.canNotRead(resources.COMPONENT_BUG_REPORT)) {
            return "";
        }

        if (!this.props.helperIsOnline) {
            return <Button disabled label={<Translate value="helper.openBugReport" />} />;
        }

        return <Button onClick={this.handleOpenBugReportSection} label={<Translate value="helper.openBugReport" />} />;
    };

    getHelpContent = (message) => {
        return (
            <div className="text-center">
                <div className="margin-bottom-8" dangerouslySetInnerHTML={{__html: message}} />
            </div>
        );
    };

    getHelpInfo = () => {
        if (this.props.params.message !== "") {
            return this.getHelpContent(this.props.params.message);
        }

        if (this.props.helpSettings.message === "") {
            return (
                <div className="text-center">
                    <div>
                        <Translate value="help.noHelpForLicense" />
                    </div>
                    <div>
                        <Translate value="help.poweredByDeso" name={config.DESO} />
                    </div>
                    <div>
                        <img src={imgDeso} className="deso-logo" alt="deso logo" />
                    </div>
                </div>
            );
        }

        return this.getHelpContent(this.props.helpSettings.message);
    };

    getContent = () => {
        return modelHelper.buildModalSection(this.getHelpInfo());
    };

    getFooter = () => {
        return modelHelper.buildModalSection(
            <React.Fragment>
                {this.getBugReportButton()}
                <CloseButton onClick={this.handleCloseModalClick} />
            </React.Fragment>
        );
    };

    render() {
        return (
            <Modal
                modalId={this.props.tabId}
                onClose={this.handleCloseModalClick}
                header={modelHelper.buildModalSection(<Translate value="help.help" />)}
                content={this.getContent()}
                footer={this.getFooter()}
                styles={{minHeight: "50%", minWidth: "50%"}}
            />
        );
    }
}
